module.exports = __webpack_public_path__ + "static/media/autofarm.e112c6df.webp";